import Moment from 'react-moment';
import { useDispatch, useSelector } from "react-redux";
import { getSignMessage } from "../../slices/sign_message";
import React, { useState, useEffect,useMemo } from 'react';

const NiceSignMessage = (props) => {

const messageID = props.children
const signMessage = useSelector((state) => state.signMessage.data.list.find(message => message.id === messageID));  

const dispatch = useDispatch();

useEffect(() => {

  if (!signMessage && messageID > 0){
    dispatch(getSignMessage(messageID));
  }

}, [signMessage]);

if (messageID <= 0)
{
  return "Default Message"
}

return (
      signMessage?.message
  )
}

export default NiceSignMessage;